import React from 'react';
import { HeroSection } from './HeroSection';
import { SalesContent } from './SalesContent';
import { MathProofSection } from './MathProofSection';
import { RevealSection } from './RevealSection';
import { SurvivorBenefitSection } from './SurvivorBenefitSection';
import { MidPageCTA } from './MidPageCTA';
import { IsThisForYouSection } from './IsThisForYouSection';
import { ProductSection } from './ProductSection';
import { UrgencySection } from './UrgencySection';
import { GuaranteeSection } from './GuaranteeSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-[#FAF8F5] font-serif text-[#1B2A4A]" data-id="element-196">
      <main className="max-w-[680px] mx-auto px-6 py-12 md:py-20" data-id="element-197">
        <HeroSection data-id="element-198" />
        <SalesContent data-id="element-199" />
        <MathProofSection data-id="element-200" />
        <RevealSection data-id="element-201" />
        <SurvivorBenefitSection data-id="element-202" />
        <MidPageCTA data-id="element-203" />
        <IsThisForYouSection data-id="element-204" />
        <ProductSection data-id="element-205" />
        <UrgencySection data-id="element-206" />
        <GuaranteeSection data-id="element-207" />
        <CTASection data-id="element-208" />
      </main>

      <Footer data-id="element-209" />
    </div>;
}